// extracted by mini-css-extract-plugin
module.exports = {"help":"help_help__3ZgIj","notice":"help_notice__1Zn89"};